<template>

  <div class="locations-list">

    <div class="single-location-wrap" v-if="stats">

      <div class="col-map">
        <a class="map-wrap-link" :href="current_location.acf_locations.direction" target="_blank">
          <div class="footer-map" v-if="stats" :style="{'background-image': 'url(' + current_location.acf_locations.location_map + ') '}"></div>
        </a>
      </div>

      <div class="col-details">
        <div class="dropdown">
          <button type="button" class="btn dropdown-toggle" data-toggle="dropdown" data-display="static">

            <span v-if="stats && !is_spanish">{{ current_location.post_title }}</span>
            <span v-if="stats && is_spanish">{{ current_location.acf_locations.spanish_title }}</span>

            <span class="icon-dropdown">
                     <img :src="theme_path + '/assets/images/arrow-dropdown.svg' " alt="arrow"/>
                </span>
          </button>
          <div class="dropdown-menu">
            <ul>
              <li
                  v-for="(location, index) in locations"
                  v-on:click="onChangeSelect(index, location.ID)"
              >
                <template v-if="!is_spanish">
                  {{ location.post_title }}
                </template>
                <template v-if="is_spanish">
                  {{ location.acf_locations.spanish_title }}
                </template>
              </li>
            </ul>
          </div>
        </div>
        <div class="inner-wrap">

          <div class="firm-name">{{ current_location.acf_locations.firm_name }}</div>

          <div class="address-wrap">
            <p class="address" v-if="current_location.acf_locations.address_1">
              {{ current_location.acf_locations.address_1 }}
            </p>
            <p class="address" v-if="current_location.acf_locations.address_2">{{ current_location.acf_locations.address_2 }}</p>
            <p>
              <span>{{ current_location.acf_locations.city }}</span>, <span>{{ current_location.acf_locations.state }}</span> <span>{{ current_location.acf_locations.zipcode }}</span>
            </p>
            <p>United States (US)</p>
            <div class="phone-wrap" v-if="current_location.acf_locations.phone">
              <p>
                <a class="phone-number ctm-no-swap" :href="'tel:' + current_location.acf_locations.phone">
                  <template v-if="!is_spanish">
                    <span>Phone:</span>
                  </template>
                  <template v-if="is_spanish">
                    <span>Teléfono:</span>
                  </template>
                  {{ current_location.acf_locations.phone }}</a>
              </p>
              <p v-if="current_location.acf_locations.phone2">
                <a class="phone-number ctm-no-swap" :href="'tel:' + current_location.acf_locations.phone2"><span>Toll Free:</span> {{ current_location.acf_locations.phone2 }}</a>
              </p>
              <p v-if="current_location.acf_locations.fax">
                <a class="phone-number ctm-no-swap" :href="'tel:' + current_location.acf_locations.fax"><span>Fax:</span> {{ current_location.acf_locations.fax }}</a>
              </p>
            </div>
            <div class="appointment" v-if="current_location.acf_locations.by_appointment_only">By Appointment Only</div>
          </div>

          <div class="btns-wrap">
            <a :href="current_location.link" class="btn btn-white">Info</a>
            <a :href="current_location.acf_locations.direction" class="btn btn-white" target="_blank">
              <template v-if="!is_spanish">
                <span>Directions</span>
              </template>
              <template v-if="is_spanish">
                <span>Direcciones</span>
              </template>
            </a>
          </div>

        </div>
      </div>


    </div>

  </div>

</template>

<script>

export default {
  name: 'app',
  data: () => ({
    theme_path: WPsettings.theme_path,
    is_spanish: WPsettings.is_spanish,
    locations: null,
    current_location: null,
    stats: null
  }),
  methods: {
    getAllLocations: function () {

      var self = this;

      var data = {
        'action': 'my_locations_func',
        'whatever': "test"      // We pass php values differently!
        // 'whatever': ajax_object.we_value      // We pass php values differently!
      };

      jQuery.ajax(
          {
            dataType: 'json',
            data: data,
            url: WPsettings.ajaxurl,
          })
          .done(function (data, textStatus, jqXHR) {

            self.locations = data;

            let selected_location = data[0].acf_locations.selected_location.ID;

            let result = data.filter(page => {
              if (page.ID == selected_location) {
                return page;
              }
            });

            if (result.length < 1) {
              self.current_location = data[0];
            } else {
              self.current_location = result[0];
            }

            self.stats = true;

          })
          .fail(function () {
            console.error("REST error. Nothing returned for AJAX.");
          })
          .always(function () {

          });

    },
    onChangeSelect: function (index, id) {
      this.current_location = this.locations[index];
    }
  },
  created() {
    this.getAllLocations();
  },
  mounted: function () {
    this.$nextTick(function () {
      // Code that will run only after the
      // entire view has been rendered
    });
  },
  beforeUpdate: function () {
  },
  watch: {
    // whenever question changes, this function will run
    locations: function (newQuestion, oldQuestion) {

      var self = this;

      if (self.stats == true) {

        function preloader() {
          if (document.images) {
            var i;
            var images = new Array();
            for (i = 0; i < self.locations.length; i++) {
              images[i] = new Image();
              images[i].src = self.locations[i].acf_locations.location_map;
            }
          }
        }

        preloader();

      }

    }
  }
}
</script>

<style>
</style>
